module.exports = __webpack_public_path__ + "6cc9959e90401af41f64c5d2d32082d4.woff";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-regular.woff
// module id = 1138
// module chunks = 0